export default {
  // 方法1
  testMethod1: function () {
    console.log('对，我只是一个测试公共方法')
  },
  // 方法2
  testMethod2: function (val) {
    console.log('巧了，我也是测试公共方法，我是', val)
  },
  
	publicshareOut:function (val,val1,val2) {
		//val.link
		var path=val1.api.api.urls+'/?state='+sessionStorage.getItem('appid')+'&number=shareinfo&userid='+sessionStorage.getItem('fxuserid')+'&agencyid='+sessionStorage.getItem('agencyid');
		path=path+'&pointid='+sessionStorage.getItem('pointid');
		if(sessionStorage.getItem('userid'))
		{
			path=path+'&ffuserid='+sessionStorage.getItem('userid');
		}
		else
		{
			path=path+'&ffuserid='+sessionStorage.getItem('ffuserid');
		}
		/*var path=val1.api.api.urls+'/?state='+sessionStorage.getItem('appid');
		var parameterinfo='{"fxuserid":"'+sessionStorage.getItem('fxuserid')+'","agencyid":"'+sessionStorage.getItem('agencyid')+'"';
		parameterinfo=parameterinfo+',"pointid":"'+sessionStorage.getItem('pointid')+'"';
		if(sessionStorage.getItem('userid'))
		{
			parameterinfo=parameterinfo+',"ffuserid":"'+sessionStorage.getItem('userid')+'"';
		}
		else
		{
			parameterinfo=parameterinfo+',"ffuserid":"'+sessionStorage.getItem('ffuserid')+'"';
		}*/
		
		var descx='';//、学习轨迹记录，让学生高效学，精准备战小升初
		// 小升初择校真题试卷（可下载打印）、答案、每题视频解析、日常错题集！
		let params = {
			"api": "jg_gl",
			"agencyid": sessionStorage.getItem('agencyid'),//Vue.prototype._isiOS() 
			"type":'3',
		}       
		val1.$axios({
			method: 'post',
			url: val1.api.api.url,
			data: params
		}).then((res)=>{

			if(val.title=="")
			{
				val.title=res.data.sharetitle+"("+sessionStorage.getItem('agencyname')+")";
			}
			else
			{
				if(val.title=="zxinfo")
				{
					val.title=res.data.zxsharetitle;
					val.descx=res.data.zxshareexplain;
				}
				if(val.title=="zxinfos")
				{
					val.title=res.data.zxsharetitle+'('+val.descx+')';
					val.descx=res.data.zxshareexplain;
				}				
			}

			descx=res.data.shareexplain;	
					
			if(val.descx)
			{
				descx=val.descx;
				path=val.link;
			}
			if(val.desc=='2')
			{
				descx='';
			}
			if(val2!='')
			{
				path=path+'&'+val2;
			}
			
			var obj = {
				title:val.title,                //标题
				desc:descx,          //描述
				link:path,
				imgUrl:val1.api.api.urls+sessionStorage.getItem('agencylogo')
			};
			params = {
				"api": "getautograph",
				"userid": sessionStorage.getItem('userid'),//Vue.prototype._isiOS() 
				"url": val.url,//location.href.split('#')[0]
				"appid":sessionStorage.getItem('appid'),
				
			}       
			val1.$axios({
				method: 'post',
				url: val1.api.api.url,
				data: params
			}).then((res)=>{
				//拼接sha1加密字符串
				//var r = eval( '(' + res.data + ')' );
				//console.log(r);
				wx.config({
					debug: false,
					appId: res.data.data.appid,     //appId
					timestamp: res.data.data.timestamp,            //时间戳
					nonceStr: res.data.data.noncestr,              //加密需要字符串(自己定义的)        
					signature: res.data.data.signature,            //sha1加密后字符串
					jsApiList: [ 'updateAppMessageShareData','updateTimelineShareData','onMenuShareTimeline', 'onMenuShareAppMessage','onMenuShareQQ','onMenuShareWeibo']
				});
				wx.checkJsApi({
					jsApiList: [
						// 所有要调用的 API 都要加到这个列表中
						'updateAppMessageShareData',
						'updateTimelineShareData',
						'onMenuShareTimeline', // 分享到朋友圈接口
						'onMenuShareAppMessage', //  分享到朋友接口
						'onMenuShareQQ', // 分享到QQ接口
						'onMenuShareWeibo' // 分享到微博接口
					],
					success: function (res) {}
				})                
				wx.ready(function () 
				{
					var _this=val1;  	
					var shareData = {
						imgUrl: obj.imgUrl, // 分享显示的缩略图地址
						link: obj.link, // 分享地址
						desc: obj.desc, // 分享描述
						title: obj.title, // 分享标题
						success: function () {
						// 分享成功可以做相应的数据处理
						//_this.$layer.msg('分享成功')         				
						},
						fail: function () {
							//_this.$layer.msg('调用失败')
						},
						complete: function () {
							//_this.$layer.msg('调用结束')
						}
					}                		
					//分享到朋友圈"
					wx.updateTimelineShareData(shareData);
					//分享给朋友
					wx.updateAppMessageShareData(shareData);
					wx.onMenuShareQQ(shareData);
					wx.onMenuShareWeibo(shareData);
					return true;
				},function (res) {
					val1.$layer.msg(res);
				}
				)
			})		
					
					
					
					
		})	
	},  
  
	taskshare:function (that,title,descx,taskid) {
		//val.link
		let urlz='';
		if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
			//ios
			urlz=decodeURIComponent(location.href.split('#')[0] );
		} else if (/(Android)/i.test(navigator.userAgent)) {
			//android
			urlz=location.href.split('#')[0] ;
		}		
		var path=that.api.api.urls+'/?state='+sessionStorage.getItem('appid')+'&number=taskshare&userid='+sessionStorage.getItem('fxuserid')+'&agencyid='+sessionStorage.getItem('agencyid');
		path=path+'&pointid='+sessionStorage.getItem('pointid');
		if(sessionStorage.getItem('userid'))
		{
			path=path+'&ffuserid='+sessionStorage.getItem('userid');
		}
		else
		{
			path=path+'&ffuserid='+sessionStorage.getItem('ffuserid');
		}
		path=path+'&taskid='+taskid;
		var obj = {
			title:title,                //标题
			desc:descx,          //描述
			link:path,
			imgUrl:that.api.api.urls+sessionStorage.getItem('agencylogo')
		};
		var params = {
			"api": "getautograph",
			"userid": sessionStorage.getItem('userid'),//Vue.prototype._isiOS() 
			"url": urlz,//location.href.split('#')[0]
			"appid":sessionStorage.getItem('appid'),
			
		}       
		that.$axios({
			method: 'post',
			url: that.api.api.url,
			data: params
		}).then((res)=>{
			//拼接sha1加密字符串
			//var r = eval( '(' + res.data + ')' );
			//console.log(r);
			wx.config({
				debug: false,
				appId: res.data.data.appid,     //appId
				timestamp: res.data.data.timestamp,            //时间戳
				nonceStr: res.data.data.noncestr,              //加密需要字符串(自己定义的)        
				signature: res.data.data.signature,            //sha1加密后字符串
				jsApiList: [ 'updateAppMessageShareData','updateTimelineShareData','onMenuShareTimeline', 'onMenuShareAppMessage','onMenuShareQQ','onMenuShareWeibo']
			});
			wx.checkJsApi({
				jsApiList: [
					// 所有要调用的 API 都要加到这个列表中
					'updateAppMessageShareData',
					'updateTimelineShareData',
					'onMenuShareTimeline', // 分享到朋友圈接口
					'onMenuShareAppMessage', //  分享到朋友接口
					'onMenuShareQQ', // 分享到QQ接口
					'onMenuShareWeibo' // 分享到微博接口
				],
				success: function (res) {}
			})                
			wx.ready(function () 
			{
				var _this=that;  	
				var shareData = {
					imgUrl: obj.imgUrl, // 分享显示的缩略图地址
					link: obj.link, // 分享地址
					desc: obj.desc, // 分享描述
					title: obj.title, // 分享标题
					success: function () {
					// 分享成功可以做相应的数据处理
					//_this.$layer.msg('分享成功')         				
					},
					fail: function () {
						//_this.$layer.msg('调用失败')
					},
					complete: function () {
						//_this.$layer.msg('调用结束')
					}
				}                		
				//分享到朋友圈"
				wx.updateTimelineShareData(shareData);
				//分享给朋友
				wx.updateAppMessageShareData(shareData);
				wx.onMenuShareQQ(shareData);
				wx.onMenuShareWeibo(shareData);
				return true;
			},function (res) {
				that.$layer.msg(res);
			}
			)
		})					
	},   
	evaluating:function (that,title,descx,taskid) {
		//val.link
		let urlz='';
		if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
			//ios
			urlz=decodeURIComponent(location.href.split('#')[0] );
		} else if (/(Android)/i.test(navigator.userAgent)) {
			//android
			urlz=location.href.split('#')[0] ;
		}		
		var path=that.api.api.urls+'/?state='+sessionStorage.getItem('appid')+'&number=evaluating&agencyid='+sessionStorage.getItem('agencyid');
		path=path+'&pointid='+sessionStorage.getItem('pointid');
		path=path+'&taskid='+taskid;
		var obj = {
			title:title,                //标题
			desc:descx,          //描述
			link:path,
			imgUrl:that.api.api.urls+sessionStorage.getItem('agencylogo')
		};
		var params = {
			"api": "getautograph",
			"userid": sessionStorage.getItem('userid'),//Vue.prototype._isiOS() 
			"url": urlz,//location.href.split('#')[0]
			"appid":sessionStorage.getItem('appid'),
			
		}       
		that.$axios({
			method: 'post',
			url: that.api.api.url,
			data: params
		}).then((res)=>{
			//拼接sha1加密字符串
			//var r = eval( '(' + res.data + ')' );
			//console.log(r);
			wx.config({
				debug: false,
				appId: res.data.data.appid,     //appId
				timestamp: res.data.data.timestamp,            //时间戳
				nonceStr: res.data.data.noncestr,              //加密需要字符串(自己定义的)        
				signature: res.data.data.signature,            //sha1加密后字符串
				jsApiList: [ 'updateAppMessageShareData','updateTimelineShareData','onMenuShareTimeline', 'onMenuShareAppMessage','onMenuShareQQ','onMenuShareWeibo']
			});
			wx.checkJsApi({
				jsApiList: [
					// 所有要调用的 API 都要加到这个列表中
					'updateAppMessageShareData',
					'updateTimelineShareData',
					'onMenuShareTimeline', // 分享到朋友圈接口
					'onMenuShareAppMessage', //  分享到朋友接口
					'onMenuShareQQ', // 分享到QQ接口
					'onMenuShareWeibo' // 分享到微博接口
				],
				success: function (res) {}
			})                
			wx.ready(function () 
			{
				var _this=that;  	
				var shareData = {
					imgUrl: obj.imgUrl, // 分享显示的缩略图地址
					link: obj.link, // 分享地址
					desc: obj.desc, // 分享描述
					title: obj.title, // 分享标题
					success: function () {
					// 分享成功可以做相应的数据处理
					//_this.$layer.msg('分享成功')         				
					},
					fail: function () {
						//_this.$layer.msg('调用失败')
					},
					complete: function () {
						//_this.$layer.msg('调用结束')
					}
				}                		
				//分享到朋友圈"
				wx.updateTimelineShareData(shareData);
				//分享给朋友
				wx.updateAppMessageShareData(shareData);
				wx.onMenuShareQQ(shareData);
				wx.onMenuShareWeibo(shareData);
				return true;
			},function (res) {
				that.$layer.msg(res);
			}
			)
		})					
	},    
  
	sjshareinfo:function (that,title,descx,sjid) {
		//val.link
		let urlz='';
		if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
			//ios
			urlz=decodeURIComponent(location.href.split('#')[0] );
		} else if (/(Android)/i.test(navigator.userAgent)) {
			//android
			urlz=location.href.split('#')[0] ;
		}		
		var path=that.api.api.urls+'/?state='+sessionStorage.getItem('appid')+'&number=sjshare&userid='+sessionStorage.getItem('fxuserid')+'&agencyid='+sessionStorage.getItem('agencyid');
		path=path+'&pointid='+sessionStorage.getItem('pointid');
		if(sessionStorage.getItem('userid'))
		{
			path=path+'&ffuserid='+sessionStorage.getItem('userid');
		}
		else
		{
			path=path+'&ffuserid='+sessionStorage.getItem('ffuserid');
		}
		path=path+'&sjid='+sjid;
		
		//、学习轨迹记录，让学生高效学，精准备战小升初
		// 小升初择校真题试卷（可下载打印）、答案、每题视频解析、日常错题集！
		let params = {
			"api": "jg_gl",
			"agencyid": sessionStorage.getItem('agencyid'),//Vue.prototype._isiOS() 
			"type":'3',
		}       
		that.$axios({
			method: 'post',
			url: that.api.api.url,
			data: params
		}).then((res)=>{

			if(title=="")
			{
				title=res.data.sharetitle+"("+sessionStorage.getItem('agencyname')+")";
			}

			descx=res.data.shareexplain;
							
			var obj = {
				title:title,                //标题
				desc:descx,          //描述
				link:path,
				imgUrl:that.api.api.urls+sessionStorage.getItem('agencylogo')
			};
			var params = {
				"api": "getautograph",
				"userid": sessionStorage.getItem('userid'),//Vue.prototype._isiOS() 
				"url": urlz,//location.href.split('#')[0]
				"appid":sessionStorage.getItem('appid'),
				
			}       
			that.$axios({
				method: 'post',
				url: that.api.api.url,
				data: params
			}).then((res)=>{
				//拼接sha1加密字符串
				//var r = eval( '(' + res.data + ')' );
				//console.log(r);
				wx.config({
					debug: false,
					appId: res.data.data.appid,     //appId
					timestamp: res.data.data.timestamp,            //时间戳
					nonceStr: res.data.data.noncestr,              //加密需要字符串(自己定义的)        
					signature: res.data.data.signature,            //sha1加密后字符串
					jsApiList: [ 'updateAppMessageShareData','updateTimelineShareData','onMenuShareTimeline', 'onMenuShareAppMessage','onMenuShareQQ','onMenuShareWeibo']
				});
				wx.checkJsApi({
					jsApiList: [
						// 所有要调用的 API 都要加到这个列表中
						'updateAppMessageShareData',
						'updateTimelineShareData',
						'onMenuShareTimeline', // 分享到朋友圈接口
						'onMenuShareAppMessage', //  分享到朋友接口
						'onMenuShareQQ', // 分享到QQ接口
						'onMenuShareWeibo' // 分享到微博接口
					],
					success: function (res) {}
				})                
				wx.ready(function () 
				{
					var _this=that;  	
					var shareData = {
						imgUrl: obj.imgUrl, // 分享显示的缩略图地址
						link: obj.link, // 分享地址
						desc: obj.desc, // 分享描述
						title: obj.title, // 分享标题
						success: function () {
						// 分享成功可以做相应的数据处理
						//_this.$layer.msg('分享成功')         				
						},
						fail: function () {
							//_this.$layer.msg('调用失败')
						},
						complete: function () {
							//_this.$layer.msg('调用结束')
						}
					}                		
					//分享到朋友圈"
					wx.updateTimelineShareData(shareData);
					//分享给朋友
					wx.updateAppMessageShareData(shareData);
					wx.onMenuShareQQ(shareData);
					wx.onMenuShareWeibo(shareData);
					return true;
				},function (res) {
					that.$layer.msg(res);
				}
				)
			})
		})		
	},  
  
	publicshareOut_close:function (val,val1) {
			let params = {
					"api": "getautograph",
					"userid": sessionStorage.getItem('userid'),//Vue.prototype._isiOS() 
					"url": val.url,//location.href.split('#')[0]
					"appid":sessionStorage.getItem('appid')
					}           
            val1.$axios({
          		method: 'post',
	          	url: val1.api.api.url,
	          	data: params
	        })
            .then((res)=>{
                //拼接sha1加密字符串
                //var dataObj = JSON.parse(res.data);
                //var r = eval( '(' + res.data + ')' );
                wx.config({
                    debug: false,
                    appId: res.data.data.appid,     //appId
                    timestamp: res.data.data.timestamp,            //时间戳
                    nonceStr: res.data.data.noncestr,              //加密需要字符串(自己定义的)        
                    signature: res.data.data.signature,            //sha1加密后字符串
                    jsApiList: [ 'closeWindow']
                });              
                wx.ready(function () {
                	wx.closeWindow();              
                    
                },function (res) {
					val1.$layer.msg(res);
    			})
            })
	},    
  
}



// WEBPACK FOOTER //
// ./src/public/public.js